<template>
  <div class="header-search">
    <img class="close-icon" src="/image/icon/new-close.svg" style="width:23px;height:23px;" @click="onCloseSearch">
    <div class="search-title">{{ $t('global.search-title') }}</div>
    <div class="search-input">
      <input ref="refKeyword" :placeholder="$t('global.typeKeyword')" @keypress="onSearchKeyPress">
      <img class="search-icon" src="/image/icon/new-search.svg" @click="onSearch">
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getAtModel, ACTION_TYPES } from '@/utils/atModel'

export default defineComponent({
  emits: ['close'],
  setup (props: any, context: any) {
    const router = useRouter()
    const { emit } = context
    const refKeyword = ref()
    const onCloseSearch = () => {
      emit('close')
    }
    const onSearch = () => {
      const keyword = refKeyword.value.value
      refKeyword.value.value = ''
      emit('close')
      router.push(`/search?keyword=${encodeURIComponent(keyword)}`)
    }
    const onSearchKeyPress = (e: KeyboardEvent) => {
      if (e.keyCode === 13) {
        e.preventDefault()
        const keyword = refKeyword.value.value
        getAtModel().doAtEvent(`main_menu::search::${keyword}`, ACTION_TYPES.navigation, e)
        onSearch()
      }
    }
    return {
      refKeyword,
      onCloseSearch,
      onSearchKeyPress,
      onSearch
    }
  }
})
</script>

<style lang="less" scoped>

.header-search {
  position: absolute;
  background-color: #fff;
  height: 184px;
  width: 100%;
  text-align: center;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.07);
  .search-input {
    display: flex;
    justify-content: center;
    align-items: center;
    input {
      outline: medium;
      width: 778px;
      background-color: #fff;
      border: 1px solid rgb(221, 221, 221);
      border-radius: 100px;
      padding: 0px 12px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.09);
    }
    .search-icon {
      margin-left: -40px;
    }
  }
  .search-icon, .close-icon {
    cursor: pointer;
  }
  .close-icon {
    float: right;
    margin: 24px;
  }
  .search-title {
    padding: 40px 0 24px;
    color: rgb(51, 51, 51);
    font-size: 24px;
    line-height: 34px;
    font-weight: 700;
  }
}
.rtl--container {
  .close-icon {
    float: left;
  }
  .search-icon {
    margin-left: 0 !important;
    margin-right: -40px;
  }
}
</style>
